import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Icon, RowView, RowView2 } from "../../../Component/style/common_style";

const Tuto = () => {
  const Navigate = useNavigate();
  const goAdminSign = () => {
    // Navigate("/admin/adminsign");
    Navigate("/admin/adminsignup");
  };
  return (
    <Container>
      <RowView style={{ gap: 16, display: "flex", alignItems: "stretch" }}>
        <Thimbnail
          style={{
            backgroundImage: `url(${require("../../../Image/image_thimbnail_base.png")})`,
          }}
          onClick={() => {
            Navigate("/tutorial");
          }}
        >
          <RowView2>
            <Icon src={require("../../../Image/ic_live_on.png")} />

            <ViewCount>{0}명 시청</ViewCount>
          </RowView2>
          <Title>셀러 테스트 방송</Title>
          <GoBtn>
            입장하기
            <Icon
              style={{ height: 16 }}
              src={require("../../../Image/ic_arrow_right_black.png")}
            />
          </GoBtn>
        </Thimbnail>
        <BtnDiv>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
            onClick={() => {
              Navigate("/tutorial", { state: { modalOn: true } });
            }}
          >
            <Icon src={require("../../../Image/ic_postit.png")} />
            기능 안내
          </div>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
            onClick={goAdminSign}
          >
            <Icon src={require("../../../Image/ic_open.png")} />
            입점하기
          </div>
        </BtnDiv>
      </RowView>
    </Container>
  );
};

export default Tuto;

const Container = styled.div`
  padding: 16px;
  margin-top: 25px;
`;

const Thimbnail = styled.div`
  flex: 1;
  position: relative;
  background-size: cover;
  background-position: center;
  width: 100%;
  aspect-ratio: 9/11; /* 일정한 비율 유지 */
  border-radius: 8px;
  box-sizing: border-box;
  padding: 8px;
  cursor: pointer;
`;

const ViewCount = styled.div`
  background-color: black;
  padding: 0px 6px;
  height: 20px;
  line-height: 20px; /* 높이와 동일하게 설정하여 수직 가운데 정렬 */
  border-radius: 4px;
  font-size: 12px;
  margin-left: 5px;
  display: inline-block; /* 한 줄 텍스트를 위한 설정 */
  overflow: hidden; /* 넘치는 텍스트 숨김 */
  text-overflow: ellipsis; /* 넘치는 텍스트를 ...으로 표시 */
  white-space: nowrap; /* 텍스트를 한 줄로 유지 */
  text-align: center; /* 수평 가운데 정렬 */
`;

const Title = styled.div`
  font-size: 16px;
  font-family: var(--font-Pretendard-Bold);
  margin-top: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const GoBtn = styled.div`
  position: absolute;
  justify-self: center;
  width: 90%;
  height: 40px;
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-family: var(--font-Pretendard-SemiBold);
  flex-direction: row;
  bottom: 15px;
  gap: 5px;
`;

const BtnDiv = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  font-size: 14px;
  cursor: pointer;
`;
